export default __webpack_public_path__ + "static/media/flight.505f04d5.svg";